import * as Types from "../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
export type ActualBalancesFieldsFragment = {
  __typename?: "actual_balances";
} & Pick<
  Types.Actual_Balances,
  | "id"
  | "balance"
  | "balance_gbp"
  | "date"
  | "maturity_date"
  | "interest_rate"
  | "created_at"
>;

export const ActualBalancesFieldsFragmentDoc = gql`
  fragment actualBalancesFields on actual_balances {
    id
    balance
    balance_gbp
    date
    maturity_date
    interest_rate
    created_at
  }
`;
